export enum SubUserDetailTab {
  Onboarding = "Onboarding",
  LearningAssets = "Learning Assets",
  ScenarioConversation = "Scenario Conversation",
  LessonReview = "Lesson Review",
}
